module.exports = __webpack_public_path__ + "img/snow-center.f5cc8505.svg";